import {
  ArticleType,
  AssetType,
  CustomLanguage,
  CustomRegistry,
  CustomTheme,
  OnboardingFulfilledBy,
  PaymentMethodType,
  PurchaseCountry,
} from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredEnumArray, requiredNumber, requiredString } from '@/utils/zodUtils';

export const AgentConfigurationFormSchema = (t: GetTextIdTranslationType) =>
  z.object({
    name: requiredString(t),
    customTheme: requiredEnum(CustomTheme, t),
    customRegistry: requiredEnum(CustomRegistry, t),
    customLanguage: requiredEnum(CustomLanguage, t),
    communicationsAreAllowed: z.boolean(),
    isBankReaderEnabled: z.boolean(),
    quotaSelectionByBorrowerIsAllowed: z.boolean(),
    isDocumentationRequiredManagementEnabled: z.boolean(),
    areCertificationsEnabled: z.boolean(),
    maxBankReaderAttempts: requiredNumber(t, 0),
    allowedPurchaseCountries: requiredEnumArray(PurchaseCountry, t),
    allowedAssetTypes: requiredEnumArray(AssetType, t),
    allowedOnboardingFulfilledByTypes: requiredEnumArray(OnboardingFulfilledBy, t),
    allowedArticleTypes: requiredEnumArray(ArticleType, t, true),
    allowedPaymentMethodTypes: requiredEnumArray(PaymentMethodType, t),
    isStatusAnalysingEnabled: z.boolean(),
  });

export type AgentConfigurationFormType = z.infer<ReturnType<typeof AgentConfigurationFormSchema>>;
